// src/common/wrappers/nested-property.js

'use strict';

module.exports = function getNestedProperty(obj, path) {
  var value = obj;
  var parts = path.split('.');

  parts.some(function (part) {
    if (typeof value === 'object') {
      value = value[part];
    } else {
      value = null;
    }

    return value === null || typeof value === 'undefined';
  });

  return value;
};
